import styled from 'styled-components';
import { motion, useInView } from "framer-motion"
import React, { useRef } from 'react';
import Slide from '../containers/Slide';
import { Link } from "react-scroll";
import AccentLine from '../widgets/AccentLine';
import EmailIcon from "../../res/icons/email.svg";
import GithubIcon from "../../res/icons/github.svg";
import DevopsSpinnerIcon from "../../res/icons/devops-spinner2.svg";
import LinkedinIcon from "../../res/icons/linkedin.svg";
import HeroBg from '../../res/images/hero.png';
import TriangleScrollToButton from '../widgets/TriangleScrollToButton';
import FilledButton from '../buttons/FilledButton';

const Container = styled.div.attrs({ className: "home-slide" })`
    width: 100%;
    height: 100%;
    display: flex;
    // gap: var(--global-border-width);
    color: var(--black);

    section {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;

        .slide-half-content {
            width: 70%;
            height: 500px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 2rem;
            // background: red;
        }
    }

    #left-of-slide {
        color: var(--white);
        // text-shadow:
        // -1px -1px 0 #000,
        // 1px -1px 0 #000,
        // -1px 1px 0 #000,
        // 1px 1px 0 #000;
        border-right: 12px solid var(--brand);
        // background-image: url(${HeroBg});
        // background-position: center;
        // background-size: cover;
        // mix-blend-mode: screen;
        background: radial-gradient(100% 100% at 22% 20%, rgba(255, 255, 255, .25), transparent 55%), linear-gradient(135deg, color-mix(in srgb, var(--brand) 90%, #000), var(--brand-2));

        .pill {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            padding: 10px 14px;
            border-radius: 999px;
            background: rgba(255, 255, 255, .14);
            border: 1px solid rgba(255, 255, 255, .18);
            backdrop-filter: blur(8px);
            font-weight: 700;
            letter-spacing: .2px;
            width: fit-content;
        }

        h1 {
            font-size: 3.6rem;

            span {
                color: var(--yellow);
                font-size: 4rem;
                position: relative;
                
                &::after {
                    content: "";
                    position: absolute;
                    bottom: -14px;
                    left: 0;
                    width: 100%;
                    height: 20px;
                    border-top: 4px solid var(--yellow);
                    border-radius: 100%;
                }
            }
        }
    
        h3 {
            font-weight: normal;
        }

        #hero-button-container {
            display: flex;
            gap: 1rem;
            cursor: pointer;
        }

        a {
            position: relative;
            width: 100%;
            height: 4rem;
            border-top: var(--global-border-width) solid var(--black);
            border-bottom: var(--global-border-width) solid var(--black);
            display: flex;
            justify-content: center;
            align-items: center;
            color:var(--black);
            transition: 0.3s;
            font-weight: bold;
            font-size: 1.2rem;

            &:hover {
                background: var(--dark-white);
            }

            &:hover ~ .accent-line {
                background: var(--red);
            }
        }
    }

    #right-of-slide {
        color: var(--white);
        border-left: 12px solid var(--brand-3);
        background-image: url(${HeroBg});
        background-position: center;
        background-size: cover;

        #hero-services-container {
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.1);
            border: 1px solid rgba(255, 255, 255, .18);
            border-radius: var(--radius-lg);
            padding: 18px;
            backdrop-filter: blur(10px);
            display: none;
            gap: 12px;

            ul {
                display: grid;
                gap: 10px;
                margin: 0;
                padding: 0;
                list-style: none;
            }

            li {
                display: flex;
                gap: 10px;
                align-items: flex-start;
                background: rgba(255, 255, 255, .10);
                border: 1px solid rgba(255, 255, 255, .14);
                padding: 12px;
                border-radius: 16px;
            }

            li span {
                display: block;
                color: rgba(255, 255, 255, .82);
                font-size: 13px;
                margin-top: 2px;
            }

            li > span {
                width: 12px;
                height: 12px;
                border-radius: 999px;
                background: white;
                opacity: .92;
                margin-top: 4px;
                box-shadow: 0 10px 20px rgba(0, 0, 0, .15);
            }
        }
    
        h2 {
            font-size: 1.8rem;
            color: var(--brand-3);
        }

        p {
            font-size: 1.4rem;
            font-weight: normal;
            color: var(--brand);
        }
    }

    @media screen and (max-width: 700px) {
        #left-of-slide {    
            #profile-pic-outer-container {
                width: 180px;
                height: 180px;

                #profile-pic-inner-container {
                    width: 140px;
                    height: 140px;
                }

                #anim-spinner {
                    width: 180px;
                    height: 180px;
                    margin: -90px 0 0 -90px;
                }
            }
        }
    }

    @media screen and (max-width: 600px) {
        flex-direction: column;

        #left-of-slide {    
            text-align: center;

            h1 {
                font-size: 2.6rem;

                span {
                    font-size: 3rem;
                }
            }

            h3 {
                font-size: 1.2rem;
            }

            #profile-pic-outer-container {
                width: 200px;
                height: 200px;

                #profile-pic-inner-container {
                    width: 140px;
                    height: 140px;
                }

                #anim-spinner {
                    width: 200px;
                    height: 200px;
                    margin: -100px 0 0 -100px;
                }
            }
        }

        section {
            width: 100%;
            height: 100%;
            .accent-line {
                display: none;
            }

            .slide-half-content {
                width: 80%;
                height: 100%;
            }
        }

        #right-of-slide {
            display: none;
        }
    }

    @media screen and (max-width: 600px) and (max-height: 750px) {
        #right-of-slide {
            h1 {
                font-size: 2rem;
            }

            h3 {
                font-size: 1.4rem;
            }
        }
    }
`

export default function HomeSlide({ children }) {

    // const [ppOuterRef, ppOuterView] = useInView();
    // const [ppInnerRef, ppInnerView] = useInView();
    // const [ppSpinnerRef, ppSpinnerView] = useInView();

    return (
        <Slide height="100dvh" color="var(--blue)">

            <TriangleScrollToButton
                scrollTarget={window.innerHeight}
                verticalPosition="bottom"
            />

            <Container>

                <section id="left-of-slide">

                    <div className='slide-half-content'>

                        <AccentLine width="75px" color='var(--white)' />
                        <AccentLine width="150px" color='var(--white)' />

                        {/* <div className='pill'>
                            Bathroom Remodeling • Flooring • Fort Lauderdale
                        </div> */}

                        <h1>
                            Modern Bathrooms.
                            <br />
                            <span>Flawless</span> Floors. 
                            <br />
                            Built to Last.
                        </h1>

                        <h3>
                            Flooring Covering Services LLC delivers clean, modern remodels with premium finishes, tight timelines, and craftsmanship you can feel every day.
                        </h3>

                        <div id='hero-button-container'>

                            <FilledButton background="var(--yellow)" text='Request a free estimate'/>

                            <FilledButton background="var(--white)" text=' Call: (732) 693-4595'/>
 
                        </div>

                    </div>

                </section>

                <section id="right-of-slide">

                    <div className='slide-half-content'>

                        <div id='hero-services-container'>

                            <ul class="hero-bullets">
                                <li class="bullet">
                                    <span class="dot" aria-hidden="true"></span>
                                    <div>
                                        <h2>Bathroom Remodeling</h2>
                                        <p>Vanities, tile, showers, fixtures, waterproofing.</p>
                                    </div>
                                </li>

                                <li class="bullet">
                                    <span class="dot" aria-hidden="true"></span>
                                    <div>
                                        <h2>Flooring Installation</h2>
                                        <p>LVP, tile, laminate—level, clean, and durable.</p>
                                    </div>
                                </li>

                                <li class="bullet">
                                    <span class="dot" aria-hidden="true"></span>
                                    <div>
                                        <h2>Detail-First Finish</h2>
                                        <p>Sharp lines, clean edges, and modern hardware.</p>
                                    </div>
                                </li>
                                <li class="bullet">
                                    <span class="dot" aria-hidden="true"></span>
                                    <div>
                                        <h2>Detail-First Finish</h2>
                                        <p>Sharp lines, clean edges, and modern hardware.</p>
                                    </div>
                                </li>
                            </ul>

                        </div>

                        {/* <div>

                            <h1> HELIANTA SOSA </h1>
                            <h3>
                                I'm a certified Project Management Professional (PMP) with a strong aptitude for driving Cross-functional delivery & operational excellence.
                            </h3>

                        </div>

                        <ul>

                            <li>
                                <Link
                                    activeClass='active'
                                    containerId='app-content'
                                    to='section-header5'
                                    spy={true}
                                    smooth={true}
                                    duration={1000}
                                    delay={300}
                                >
                                    <img src={EmailIcon} /> Email
                                </Link>
                            </li>

                            <li>
                                <a href="https://www.linkedin.com/in/helianta-s-0748613a2/" target="_blank" rel="noreferrer"> <img src={LinkedinIcon} /> LinkedIn </a>
                            </li>

                        </ul> */}

                    </div>

                </section>

            </Container>

        </Slide>
    )
}